export const safeCompanyId = companyIdVM => (typeof companyIdVM === 'undefined' ? null : companyIdVM);
